@if (searchResult$ | async; as searchResult) {
  <rask-table
    class="h-100"
    [options]="gridOptions"
    [data]="searchResult"
    [columns]="tableColumns">
  </rask-table>
}